import * as React from 'react';

import i18n from 'helper/i18n';
import noop from 'helper/noop';

import { routes } from 'defs';

import { Radio } from 'components/atoms/Radio/Radio';
import { Text } from 'components/atoms/Text/Text';
import { Spacer } from 'components/helper/Spacer/Spacer';
import ButtonBar from 'components/molecules/ButtonBar';
import ElementList from 'components/molecules/ElementList';
import Summary from 'components/molecules/Summary/Summary';
import { AnamnesisStepResolver } from 'components/organisms/Anamnesis';

export type DsgvoProps = {
	buttons: Object[];
	doSaveDsgvo: Function;
	isUpdatingAnamnesis: boolean;
	onStepCompleted: (resolver: AnamnesisStepResolver) => void;
	onNavigationClick: (targetUrl: { href: string }) => void;
	dsgvoAccepted?: boolean;
	doAddEvents: Function;
	location?: {
		search?: string;
	};
	router: {
		push: Function;
	};
};

export type DsgvoState = {
	accepted?: boolean;
};

const VALUE = {
	yes: 'yes',
	no: 'no',
};
type TValue = keyof typeof VALUE;

export default class Dsgvo extends React.Component<DsgvoProps, DsgvoState> {
	public static displayName = 'AnamnesisDsgvo';
	public static defaultProps = {
		buttons: [],
		dsgvoAccepted: false,
		doFinish: noop,
		onNavigationClick: noop,
		onStepCompleted: noop,
		doAddEvents: noop,
	};

	constructor(props: DsgvoProps) {
		super(props);

		this.state = {};
	}

	public onChangeRadio = (value: TValue) => {
		this.setState({
			accepted: value === 'yes',
		});
	};

	public onSubmitFinished = () => {
		const { doSaveDsgvo, onStepCompleted } = this.props;

		onStepCompleted({
			waitFor: 'savedDsgvo',
			actionCreator: doSaveDsgvo,
			nextRoute: routes.anamnesis.disclaimer,
			data: {
				dsgvo: this.state.accepted,
			},
		});
	};

	get shouldShowButtons(): boolean {
		return typeof this.state.accepted === 'boolean';
	}

	public render() {
		const { buttons } = this.props;

		return (
			<div>
				<Summary
					title={i18n('react.impulsCoach.components.anamnesis.dsgvo.summaryTitle')}
					modifier="content"
					elements={new Array(3).fill('').map((val, index) => ({
						icon: i18n(`react.impulsCoach.components.anamnesis.dsgvo.summary${index + 1}Icon`),
						value: i18n(`react.impulsCoach.components.anamnesis.dsgvo.summary${index + 1}Value`),
					}))}
				/>
				<Spacer size="s" />
				<Text
					tag="p"
					size="m"
					textStyle="regular"
					align="left"
					text={i18n('react.impulsCoach.components.anamnesis.dsgvo.text')}
				/>
				<Spacer size="m" />
				<ElementList>
					{/* TODO use generic for onChange value type <Radio<TValue> ... /> (update typescript) */}
					<Radio
						checked={this.state.accepted === true}
						tag="li"
						id={VALUE.yes}
						name={'dsgvo'}
						value={VALUE.yes}
						label={i18n(`react.impulsCoach.components.anamnesis.dsgvo.radio.yes`)}
						onChange={(value) => this.onChangeRadio(value as TValue)}
					/>
					<Radio
						checked={this.state.accepted === false}
						tag="li"
						id={VALUE.no}
						name={'dsgvo'}
						value={VALUE.no}
						label={i18n(`react.impulsCoach.components.anamnesis.dsgvo.radio.no`)}
						onChange={(value) => this.onChangeRadio(value as TValue)}
					/>
				</ElementList>
				<Spacer size="m" />
				<div className="o-anamnesis__button-bar">
					{this.shouldShowButtons && (
						<ButtonBar
							buttons={buttons}
							loading={this.props.isUpdatingAnamnesis}
							handleButtonClicks={this.onSubmitFinished}
						/>
					)}
				</div>
			</div>
		);
	}
}
